// Types de statistiques globales
export const GLOBAL_STATISTICS_TYPES = {
  PROSPECTS_STARTED: 'prospects_started',
  PROSPECTS_FINISHED: 'prospects_finished',
  RESPONSES: 'global_responses',
  POSITIVE_RESPONSES: 'global_positive_responses',
};

// Types de statistiques email
export const EMAIL_STATISTICS_TYPES = {
  CONTACTED: 'contacted',
  DELIVERED: 'delivered',
  OPENED: 'opened',
  CLICKED: 'clicked',
  RESPONSES: 'email_responses',
  POSITIVE_RESPONSES: 'email_positive_responses',
};

// Types de statistiques LinkedIn
export const LINKEDIN_STATISTICS_TYPES = {
  CONTACTS_VISITED: 'contacts_visited',
  INVITATIONS_SENT: 'invitations_sent',
  INVITATIONS_ACCEPTED: 'invitations_accepted',
  MESSAGES_SENT: 'messages_sent',
  RESPONSES: 'linkedin_responses',
  POSITIVE_RESPONSES: 'linkedin_positive_responses',
};

// Mapping des types vers les icônes
export const STATISTICS_ICONS_MAP = {
  // Global
  [GLOBAL_STATISTICS_TYPES.PROSPECTS_STARTED]: 'multicanal',
  [GLOBAL_STATISTICS_TYPES.PROSPECTS_FINISHED]: 'user-plus',
  [GLOBAL_STATISTICS_TYPES.RESPONSES]: 'mail-open',
  [GLOBAL_STATISTICS_TYPES.POSITIVE_RESPONSES]: 'mail-recip',

  // Email
  [EMAIL_STATISTICS_TYPES.CONTACTED]: 'mail',
  [EMAIL_STATISTICS_TYPES.DELIVERED]: 'multicanal',
  [EMAIL_STATISTICS_TYPES.OPENED]: 'mail-open',
  [EMAIL_STATISTICS_TYPES.CLICKED]: 'click',
  [EMAIL_STATISTICS_TYPES.RESPONSES]: 'mail-open',
  [EMAIL_STATISTICS_TYPES.POSITIVE_RESPONSES]: 'mail-recip',

  // LinkedIn
  [LINKEDIN_STATISTICS_TYPES.CONTACTS_VISITED]: 'prospects',
  [LINKEDIN_STATISTICS_TYPES.INVITATIONS_SENT]: 'mail',
  [LINKEDIN_STATISTICS_TYPES.INVITATIONS_ACCEPTED]: 'valid2',
  [LINKEDIN_STATISTICS_TYPES.MESSAGES_SENT]: 'paper-plane-o',
  [LINKEDIN_STATISTICS_TYPES.RESPONSES]: 'mail-open',
  [LINKEDIN_STATISTICS_TYPES.POSITIVE_RESPONSES]: 'mail-recip',
};

// Catégories de statistiques
export const STATISTICS_CATEGORIES = {
  GLOBAL: 'global',
  EMAIL: 'email',
  LINKEDIN: 'linkedin',
};
